import './Footer.scss'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerSections = [
    {
      title: 'Kontakt',
      items: [
        { text: 'Husova 370, 697 01 Kyjov', icon: '📍' },
        { text: '728 108 824', icon: '📞', link: 'tel:728108824' },
        { text: 'josef.prikasky@seznam.cz', icon: '✉️', link: 'mailto:josef.prikasky@seznam.cz' },
        { text: 'Náš Facebook', icon: '📱', link: 'https://www.facebook.com/p/Auto%C5%A1kola-P%C5%99%C3%ADkask%C3%BD-Rat%C3%AD%C5%A1kovice-Kyjov-a-Hodon%C3%ADn-100051923246952/?locale=cs_CZ', operation: '_blank' }
      ]
    },
    {
      title: 'Služby',
      items: [
        { text: 'Řidičský průkaz B', link: '#sluzby' },
        { text: 'Rychlokurz', link: '#sluzby' },
        { text: 'SUV kurz', link: '#sluzby' },
        { text: 'Kondičné jízdy', link: '#sluzby' }
      ]
    },
    {
      title: 'Informace',
      items: [
        { text: 'Ceník kurzů', link: '#cenik' },
        { text: 'Recenze', link: '#recenze' },
        { text: 'Dotazy', link: '#kontakt' },
        { text: 'Ochrana osobních údajů', link: '/gdpr', isRoute: true },
        { text: 'Dopravní předpisy', link: 'https://www.mdcr.cz', external: true }
      ]
    }
  ]

  const handleScrollToSection = (link) => {
    if (link.startsWith('#')) {
      const element = document.getElementById(link.substring(1))
      if (element) {
        const headerHeight = window.innerWidth < 768 ? 80 : 100
        const elementPosition = element.offsetTop
        const offsetPosition = elementPosition - headerHeight

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  return (
    <footer className="modern-footer">
      {/* Hlavní obsah patičky */}
      <div className="footer-content">
        <div className="footer-container">
          {/* Logo a popis */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon">🚗</div>
              <div className="logo-text">
                <h3>Autoškola Příkaský</h3>
                <span>Kyjov</span>
              </div>
            </div>
            <p className="footer-description">
              Profesionální autoškola s dlouholetou tradicí. Pomáháme získat řidičský průkaz 
              rychle a bezpečně. Moderní vozový park a individuální přístup.
            </p>
            <div className="footer-stats">
              <div className="stat">
                <span className="stat-number">10+</span>
                <span className="stat-label">let zkušeností</span>
              </div>
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">absolventů</span>
              </div>
              <div className="stat">
                <span className="stat-number">Vysoká</span>
                <span className="stat-label">úspěšnost</span>
              </div>
            </div>
          </div>

          {/* Sekce s odkazy */}
          <div className="footer-sections">
            {footerSections.map((section, index) => (
              <div key={index} className="footer-section">
                <h4>{section.title}</h4>
                <ul>
                  {section.items.map((item, itemIndex) => (
                    <li key={itemIndex}>
                      {item.link ? (
                        item.external ? (
                          <a 
                            href={item.link} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="footer-link external"
                          >
                            {item.icon && <span className="link-icon">{item.icon}</span>}
                            {item.text}
                            <span className="external-icon">↗</span>
                          </a>
                        ) : item.link.startsWith('#') ? (
                          <button 
                            onClick={() => handleScrollToSection(item.link)}
                            className="footer-link"
                          >
                            {item.icon && <span className="link-icon">{item.icon}</span>}
                            {item.text}
                          </button>
                        ) : (
                          <a href={item.link} className="footer-link">
                            {item.icon && <span className="link-icon">{item.icon}</span>}
                            {item.text}
                          </a>
                        )
                      ) : (
                        <span className="footer-info">
                          {item.icon && <span className="link-icon">{item.icon}</span>}
                          {item.text}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA sekce */}
      <div className="footer-cta">
        <div className="footer-container">
          <div className="cta-content">
            <h3>Připraveni začít?</h3>
            <p>Získejte řidičský průkaz s námi. Kontaktujte nás ještě dnes!</p>
            <div className="cta-buttons">
              <a href="tel:728108824" className="cta-btn primary">
                <span className="btn-icon">📞</span>
                <span>Zavolat: 728 108 824</span>
              </a>
              <button 
                onClick={() => handleScrollToSection('#kontakt')}
                className="cta-btn secondary"
              >
                <span className="btn-icon">✉️</span>
                <span>Napsat zprávu</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Spodní lišta */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Autoškola Příkaský. Všechna práva vyhrazena.</p>
            </div>
            <div className="footer-links">
              <button onClick={() => handleScrollToSection('#kontakt')} className="bottom-link">
                Kontakt
              </button>
              <button onClick={() => handleScrollToSection('#cenik')} className="bottom-link">
                Ceník
              </button>
              <a 
                href="https://www.mdcr.cz" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bottom-link"
              >
                MDČR
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Dekorativní pozadí */}
      <div className="footer-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </footer>
  )
}

export default Footer